/***
 * 根据传入参数的字典key生成{label: 'xx', value: 'xx'}格式的数组
 * @param dict
 * @param dictKey
 * @returns {*[]|{label: *, value: string, key: number}[]}
 */
export function generateDictArrListByKey (dict, dictKey, excludeKeys = '') {
  if (!dict || !dictKey || !dict[dictKey]) return []
  let result = []
  let keys = excludeKeys.split(',')
  Object.keys(dict[dictKey]).forEach(key => {
    if (keys.includes(key)) return

    result.push({
      key: key,
      label: dict[dictKey][key],
      value: key
    })
  })
  return result
}



// WEBPACK FOOTER //
// ./src/utils/dict.js